import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import { MeProvider } from "@/context/MeContext";
import { HomeRedirect, Protected } from "@/components/Gate";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import InfoPage, { PAGE_KEYS } from "@/pages/InfoPage";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import Welcome from "@/pages/Welcome";
import Account from "@/pages/Account";
import LearnerOnboarding from "@/pages/learner/LearnerOnboarding";
import LearnerDashboard from "@/pages/learner/Dashboard";
import Library from "@/pages/learner/Library";
import CourseDetail from "@/pages/learner/CourseDetail";
import LessonPlayer from "@/pages/learner/LessonPlayer";
import MyCourses from "@/pages/learner/MyCourses";
import Profile from "@/pages/learner/Profile";
import EmployerOnboarding from "@/pages/employer/EmployerOnboarding";
import EmployerHome, { EmployerProfilePage } from "@/pages/employer/EmployerHome";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminCourseEditor from "@/pages/admin/AdminCourseEditor";
import UsersPage from "@/pages/admin/UsersPage";
import UserDetail from "@/pages/admin/UserDetail";
import RolesPage from "@/pages/admin/RolesPage";
import AdminEmployers from "@/pages/admin/AdminEmployers";
import AuditPage from "@/pages/admin/AuditPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import ModulePage from "@/pages/admin/ModulePage";
import Assessments from "@/pages/learner/Assessments";
import MyOrganisation, { PaymentResult } from "@/pages/learner/MyOrganisation";
import { BlogList, BlogPost, VerifyPage } from "@/pages/SitePages";

const shell = (roles) => <Protected roles={roles}><AppShell /></Protected>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <MeProvider>
            <Routes>
              <Route path="/" element={<HomeRedirect landing={<Landing />} />} />
              {PAGE_KEYS.map((p) => <Route key={p} path={`/${p}`} element={<InfoPage page={p} />} />)}
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
              <Route path="/verify" element={<VerifyPage />} />
              <Route path="/verify/:id" element={<VerifyPage />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/welcome" element={<Protected allowSetup><Welcome /></Protected>} />
              <Route path="/onboarding/learner" element={<Protected roles={["learner"]} allowSetup><LearnerOnboarding /></Protected>} />
              <Route path="/onboarding/employer" element={<Protected roles={["employer"]} allowSetup><EmployerOnboarding /></Protected>} />
              <Route element={shell(["learner", "admin"])}>
                <Route path="/learn/courses/:id" element={<CourseDetail />} />
                <Route path="/learn/lessons/:id" element={<LessonPlayer />} />
              </Route>
              <Route element={shell(["learner"])}>
                <Route path="/learn" element={<LearnerDashboard />} />
                <Route path="/learn/courses" element={<Library />} />
                <Route path="/learn/my-courses" element={<MyCourses />} />
                <Route path="/learn/profile" element={<Profile />} />
                <Route path="/learn/assessments" element={<Assessments />} />
                <Route path="/learn/organisation" element={<MyOrganisation />} />
                <Route path="/payment/result" element={<PaymentResult />} />
              </Route>
              <Route element={shell(["employer"])}>
                <Route path="/employer" element={<EmployerHome />} />
                <Route path="/employer/profile" element={<EmployerProfilePage />} />
              </Route>
              <Route element={shell(["admin"])}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/courses" element={<AdminCourses />} />
                <Route path="/admin/courses/:id" element={<AdminCourseEditor />} />
                <Route path="/admin/users" element={<UsersPage />} />
                <Route path="/admin/users/:id" element={<UserDetail />} />
                <Route path="/admin/roles" element={<RolesPage />} />
                <Route path="/admin/employers" element={<AdminEmployers />} />
                <Route path="/admin/audit" element={<AuditPage />} />
                <Route path="/admin/settings" element={<SettingsPage />} />
                <Route path="/admin/m/:module" element={<ModulePage />} />
              </Route>
              <Route element={shell(["learner", "employer", "admin"])}>
                <Route path="/account" element={<Account />} />
              </Route>
              <Route path="*" element={<HomeRedirect landing={<Landing />} />} />
            </Routes>
          </MeProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
